import * as React from "react";
import { FieldValueText } from "typings/index";
import { BaseFieldEditor } from "./helper";
import CustomTextInput from "~/components/baseComponent/CustomTextInput";
import styled from "styled-components";

export interface Props extends BaseFieldEditor
{
    value: FieldValueText;
    placeholder?: string;
}


interface State
{
    isEditing: boolean;
}

const Editor = styled.div`
   > span{
       clear: both;
   }
`;
class TextFieldEditor extends React.Component<Props, State>
{
    state = 
    {
        isEditing: false
    };

    private onValueChange = (value: string) =>
    {
        const fieldValue: FieldValueText = {...this.props.value, value};
        this.props.onValueChange(fieldValue);
        this.setState({ isEditing: false });
    }

    private onClick = () =>
    {
        if (!this.props.disabled)
        {
            this.setState({ isEditing: !this.state.isEditing});
        }
    }

    render()
    {
        const value = this.props.value && this.props.value.value ? this.props.value.value : "";
        return <Editor >
            <CustomTextInput 
                value={value}
                isEditing={this.state.isEditing} 
                onClick={this.onClick} 
                onDismiss={this.onClick}
                onChange={this.onValueChange}/>
        </Editor>;
    }
}

export default TextFieldEditor;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/TextFieldEditor.tsx